/**
 * Calendar Views Constants
 * Defines the available calendar view types for FullCalendar
 */

export const CALENDAR_VIEWS = {
  DAY: 'timeGridDay',
  WEEK: 'timeGridWeek',
  MONTH: 'dayGridMonth',
  YEAR: 'multiMonthYear',
  AGENDA: 'listWeek', // List view for agenda
};

export const VIEW_LABELS = {
  [CALENDAR_VIEWS.DAY]: 'Day',
  [CALENDAR_VIEWS.WEEK]: 'Week',
  [CALENDAR_VIEWS.MONTH]: 'Month',
  [CALENDAR_VIEWS.YEAR]: 'Year',
  [CALENDAR_VIEWS.AGENDA]: 'Agenda',
};

export const DEFAULT_VIEW = CALENDAR_VIEWS.MONTH;

// Views that use grouped events (2 events + "x more")
export const GROUPED_EVENT_VIEWS = [CALENDAR_VIEWS.MONTH, CALENDAR_VIEWS.YEAR];

export const VIEW_OPTIONS = [
  { label: 'Day', value: CALENDAR_VIEWS.DAY },
  { label: 'Week', value: CALENDAR_VIEWS.WEEK },
  { label: 'Month', value: CALENDAR_VIEWS.MONTH },
  // { label: 'Year', value: CALENDAR_VIEWS.YEAR },
  { label: 'Agenda', value: CALENDAR_VIEWS.AGENDA },
];

/**
 * Map simplified view names to FullCalendar view types
 * Used to convert settings values to actual calendar views
 */
export const VIEW_NAME_MAP = {
  day: CALENDAR_VIEWS.DAY,
  week: CALENDAR_VIEWS.WEEK,
  month: CALENDAR_VIEWS.MONTH,
  year: CALENDAR_VIEWS.YEAR,
  agenda: CALENDAR_VIEWS.AGENDA,
  // Support both formats
  [CALENDAR_VIEWS.DAY]: CALENDAR_VIEWS.DAY,
  [CALENDAR_VIEWS.WEEK]: CALENDAR_VIEWS.WEEK,
  [CALENDAR_VIEWS.MONTH]: CALENDAR_VIEWS.MONTH,
  [CALENDAR_VIEWS.YEAR]: CALENDAR_VIEWS.YEAR,
  [CALENDAR_VIEWS.AGENDA]: CALENDAR_VIEWS.AGENDA,
};
